import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  message,
  Input,
  InputNumber,
  Select,
  Table,
} from "antd";
import { CloseOutlined, PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { close_registry, get_open_invoices, get_open_return_invoices } from "../../../../Controllers/Registry";
import { get_all_invoices } from "../../../../Controllers/Sales/Invoices";

const { Option } = Select;

const CloseRegistryModal = ({
  visible,
  onClose,
  onRegistryClosed,
  openingBalance,
}) => {
  const [modalData, setModalData] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [selectedReturnInvoices, setSelectedReturnInvoices] = useState([]);
  const [cashOutItems, setCashOutItems] = useState([]);
  const [cashInItems, setCashInItems] = useState([]);
  const [cashCount, setCashCount] = useState(0);
  const [cardCount, setCardCount] = useState(0);
  const [customerAccountCount, setCustomerAccountCount] = useState(0);
  const [closingNote, setClosingNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [showCashInOutModal, setShowCashInOutModal] = useState(false);
  const [cashInOutType, setCashInOutType] = useState("out");
  const [cashInOutAmount, setCashInOutAmount] = useState(0);
  const [cashInOutReason, setCashInOutReason] = useState("");
  const [showCashCountModal, setShowCashCountModal] = useState(false);
  const [cashBreakdown, setCashBreakdown] = useState([
    { denomination: 200, count: 0, value: 0 },
    { denomination: 100, count: 0, value: 0 },
    { denomination: 50, count: 0, value: 0 },
    { denomination: 20, count: 0, value: 0 },
    { denomination: 10, count: 0, value: 0 },
    { denomination: 5, count: 0, value: 0 },
    { denomination: 2, count: 0, value: 0 },
    { denomination: 1, count: 0, value: 0 },
    { denomination: 0.5, count: 0, value: 0 },
    { denomination: 0.25, count: 0, value: 0 },
    { denomination: 0.2, count: 0, value: 0 },
    { denomination: 0.1, count: 0, value: 0 },
    { denomination: 0.05, count: 0, value: 0 },
  ]);

  const [paymentSummary, setPaymentSummary] = useState([]);

  const [returnPaymentSummary, setReturnPaymentSummary] = useState([]);


  useEffect(() => {
    if (visible) {
      fetchOpenInvoices();
      setCashCount(openingBalance);
    }
  }, [visible, openingBalance]);

  useEffect(() => {
    if (modalData.length > 0) {
      calculatePaymentSummary();
    }
  }, [modalData]);

  useEffect(() => {
    if (selectedReturnInvoices.length > 0) {
      calculateReturnPaymentSummary();
    }
  }, [selectedReturnInvoices]);

  const fetchOpenInvoices = async () => {
    try {
      const response = await get_all_invoices();

      const open_invoices = await get_open_invoices();

      const open_return_invoices = await get_open_return_invoices()

      console.log("open return invoices", open_invoices, open_return_invoices);

      if (response.status) {
        setModalData(open_invoices.data.invoices);
        setSelectedInvoices(open_invoices.data.invoices);
        setSelectedReturnInvoices(open_return_invoices.data.invoices);
      } else {
        message.error(open_invoices.message);
      }
    } catch (error) {
      message.error("Error fetching open invoices");
    }
  };

  const calculatePaymentSummary = () => {
    const summary = {
      cash: { amount: 0, count: 0 },
      card: { amount: 0, count: 0 },
      online: { amount: 0, count: 0 },
      cheque: { amount: 0, count: 0 },
      account: { amount: 0, count: 0 },
      other: { amount: 0, count: 0 },
    };

    modalData.forEach((invoice) => {
      let payments = [];

      if (invoice.payments) {
        if (typeof invoice.payments === 'string') {
          try {
            const parsedPayments = JSON.parse(invoice.payments);
            payments = Object.entries(parsedPayments)
              .filter(([method, amount]) => amount && amount !== "" && parseFloat(amount) > 0)
              .map(([method, amount]) => ({
                name: method,
                amount: parseFloat(amount) || 0
              }));
          } catch (error) {
            console.error('Error parsing payments JSON:', error);
          }
        } else if (Array.isArray(invoice.payments)) {
          payments = invoice.payments;
        }
      }

      payments.forEach((payment) => {
        const method = payment.name?.toLowerCase() || "";
        const amount = payment.amount || 0;

        if (amount > 0) {
          switch (method) {
            case "cash":
              summary.cash.amount += amount;
              summary.cash.count++;
              break;
            case "card":
            case "debit card":
            case "credit card":
              summary.card.amount += amount;
              summary.card.count++;
              break;
            case "online payment":
            case "online":
              summary.online.amount += amount;
              summary.online.count++;
              break;
            case "cheque":
              summary.cheque.amount += amount;
              summary.cheque.count++;
              break;
            case "bank transfer":
            case "account":
              summary.account.amount += amount;
              summary.account.count++;
              break;
            default:
              summary.other.amount += amount;
              summary.other.count++;
          }
        }
      });
    });

    const formattedSummary = [
      {
        method: "Cash",
        amount: summary.cash.amount,
        count: summary.cash.count,
      },
      {
        method: "Card",
        amount: summary.card.amount,
        count: summary.card.count,
      },
      {
        method: "Online Payment",
        amount: summary.online.amount,
        count: summary.online.count,
      },
      {
        method: "Cheque",
        amount: summary.cheque.amount,
        count: summary.cheque.count,
      },
      {
        method: "Customer Account",
        amount: summary.account.amount,
        count: summary.account.count,
      },
      {
        method: "Other",
        amount: summary.other.amount,
        count: summary.other.count,
      },
    ].filter((item) => item.amount > 0);

    setPaymentSummary(formattedSummary);
  };

  const calculateReturnPaymentSummary = () => {
    const summary = {
      cash: { amount: 0, count: 0 },
      card: { amount: 0, count: 0 },
      online: { amount: 0, count: 0 },
      cheque: { amount: 0, count: 0 },
      account: { amount: 0, count: 0 },
      other: { amount: 0, count: 0 },
    };

    selectedReturnInvoices.forEach((invoice) => {
      let payments = [];

      if (invoice.payments) {
        if (typeof invoice.payments === 'string') {
          try {
            const parsedPayments = JSON.parse(invoice.payments);
            payments = Object.entries(parsedPayments)
              .filter(([method, amount]) => amount && amount !== "" && parseFloat(amount) > 0)
              .map(([method, amount]) => ({
                name: method,
                amount: parseFloat(amount) || 0
              }));
          } catch (error) {
            console.error('Error parsing payments JSON:', error);
          }
        } else if (Array.isArray(invoice.payments)) {
          payments = invoice.payments;
        }
      }

      payments.forEach((payment) => {
        const method = payment.name?.toLowerCase() || "";
        const amount = payment.amount || 0;

        if (amount > 0) {
          switch (method) {
            case "cash":
              summary.cash.amount += amount;
              summary.cash.count++;
              break;
            case "card":
            case "debit card":
            case "credit card":
              summary.card.amount += amount;
              summary.card.count++;
              break;
            case "online payment":
            case "online":
              summary.online.amount += amount;
              summary.online.count++;
              break;
            case "cheque":
              summary.cheque.amount += amount;
              summary.cheque.count++;
              break;
            case "bank transfer":
            case "account":
              summary.account.amount += amount;
              summary.account.count++;
              break;
            default:
              summary.other.amount += amount;
              summary.other.count++;
          }
        }
      });
    });

    const formattedSummary = [
      {
        method: "Cash",
        amount: summary.cash.amount,
        count: summary.cash.count,
      },
      {
        method: "Card",
        amount: summary.card.amount,
        count: summary.card.count,
      },
      {
        method: "Online Payment",
        amount: summary.online.amount,
        count: summary.online.count,
      },
      {
        method: "Cheque",
        amount: summary.cheque.amount,
        count: summary.cheque.count,
      },
      {
        method: "Customer Account",
        amount: summary.account.amount,
        count: summary.account.count,
      },
      {
        method: "Other",
        amount: summary.other.amount,
        count: summary.other.count,
      },
    ].filter((item) => item.amount > 0);

    setReturnPaymentSummary(formattedSummary);
  };

  const addCashTransaction = () => {
    if (!cashInOutReason || cashInOutAmount <= 0) {
      message.error("Please provide a reason and amount");
      return;
    }

    const newTransaction = {
      id: Date.now(),
      reason: cashInOutReason,
      amount: cashInOutAmount,
      type: cashInOutType,
    };

    if (cashInOutType === "out") {
      setCashOutItems([...cashOutItems, newTransaction]);
    } else {
      setCashInItems([...cashInItems, newTransaction]);
    }

    setCashInOutReason("");
    setCashInOutAmount(0);
    setShowCashInOutModal(false);
  };

  const removeCashTransaction = (id, type) => {
    if (type === "out") {
      setCashOutItems(cashOutItems.filter((item) => item.id !== id));
    } else {
      setCashInItems(cashInItems.filter((item) => item.id !== id));
    }
  };

  const calculateTotalCashOut = () => {
    return cashOutItems.reduce((sum, item) => sum + (item.amount || 0), 0);
  };

  const calculateTotalCashIn = () => {
    return cashInItems.reduce((sum, item) => sum + (item.amount || 0), 0);
  };

  const calculateTotalSales = () => {
    return selectedInvoices.reduce(
      (sum, invoice) => sum + (invoice.total || 0),
      0
    );
  };

  const calculateTotalSalesReturn = () => {
    return selectedReturnInvoices.reduce(
      (sum, invoice) => sum + (invoice.total || 0),
      0
    );
  };

  const calculateCashTotal = () => {
    const totalCashFromInvoices = selectedInvoices.reduce((sum, invoice) => {
      let cashAmount = 0;

      if (invoice.payments) {
        if (typeof invoice.payments === 'string') {
          try {
            const parsedPayments = JSON.parse(invoice.payments);
            cashAmount = parseFloat(parsedPayments.Cash) || 0;
          } catch (error) {
            console.error('Error parsing payments JSON:', error);
          }
        } else if (Array.isArray(invoice.payments)) {
          cashAmount = invoice.payments
            .filter(p => p.name?.toLowerCase() === "cash")
            .reduce((pSum, payment) => pSum + (payment.amount || 0), 0);
        }
      }

      return sum + cashAmount;
    }, 0);

    return (
      totalCashFromInvoices + calculateTotalCashIn() - calculateTotalCashOut()
    );
  };

  const calculateReturnCashTotal = () => {
    const totalCashFromInvoices = selectedReturnInvoices.reduce((sum, invoice) => {
      let cashAmount = 0;

      if (invoice.payments) {
        if (typeof invoice.payments === 'string') {
          try {
            const parsedPayments = JSON.parse(invoice.payments);
            cashAmount = parseFloat(parsedPayments.Cash) || 0;
          } catch (error) {
            console.error('Error parsing payments JSON:', error);
          }
        } else if (Array.isArray(invoice.payments)) {
          cashAmount = invoice.payments
            .filter(p => p.name?.toLowerCase() === "cash")
            .reduce((pSum, payment) => pSum + (payment.amount || 0), 0);
        }
      }

      return sum + cashAmount;
    }, 0);

    return totalCashFromInvoices;

  };

  const expectedCash = (openingBalance + calculateCashTotal()) - calculateReturnCashTotal();
  const cashDifference = cashCount - expectedCash;

  const updateCashBreakdown = (index, count) => {
    const updated = [...cashBreakdown];
    updated[index].count = count;
    updated[index].value = count * updated[index].denomination;
    setCashBreakdown(updated);

    const total = updated.reduce((sum, item) => sum + item.value, 0);
    setCashCount(total);
  };

  const handleCashCountChange = (value) => {
    setCashCount(value || 0);
  };

  const resetCashCount = () => {
    setCashCount(expectedCash);
    setCashBreakdown(
      cashBreakdown.map((item) => ({ ...item, count: 0, value: 0 }))
    );
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const cashOutTransactions = cashOutItems.map((item) => ({
        description: item.reason,
        amount: item.amount,
      }));

      const cashInTransactions = cashInItems.map((item) => ({
        description: item.reason,
        amount: item.amount,
      }));

      const response = await close_registry({
        closing_balance: cashCount,
        notes: closingNote,
        cash_out: cashOutTransactions,
        cash_in: cashInTransactions,
        invoice_ids: selectedInvoices.map((inv) => inv._id),
        return_invoice_ids: selectedReturnInvoices.map((inv) => inv._id),
        counted_cash: cashCount,
        cash_difference: cashDifference,
      });

      if (response.status) {
        message.success("Registry closed successfully");
        onRegistryClosed();
        onClose();
      } else {
        message.error(response.message);
      }
    } catch (error) {
      console.error("Error closing registry:", error);
      message.error("Error closing registry");
    }
    setLoading(false);
  };

  const handleCancel = () => {
    onClose();
    setModalData([]);
    setSelectedInvoices([]);
    setSelectedReturnInvoices([]);
    setCashOutItems([]);
    setCashInItems([]);
  };

  const paymentSummaryColumns = [
    {
      title: "Payment Method",
      dataIndex: "method",
      key: "method",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => amount.toFixed(3),
      align: "right",
    },
    {
      title: "Count",
      dataIndex: "count",
      key: "count",
      align: "center",
    },
  ];

  return (
    <>
      <Modal
        onCancel={onClose}
        open={visible}
        title="Close Register"
        footer={null}
        width={700}
        style={{
          top: 20,
          maxWidth: "90%",
        }}
        bodyStyle={{
          maxHeight: "80vh",
          overflowY: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none"
        }}
      >
        <div className="mb-4">
          <div className="mb-4 flex justify-between items-center">
            <div className="text-lg">
              {selectedInvoices.length} orders:{" "}
              {calculateTotalSales().toFixed(3)}
            </div>
            <div className="text-lg">
              {selectedReturnInvoices.length} return orders:{" "}
              {calculateTotalSalesReturn().toFixed(3)}
            </div>
          </div>

          <div className="mb-4 p-3 border rounded">
            <div className="font-medium mb-2">Payment Summary</div>
            <Table
              dataSource={paymentSummary}
              columns={paymentSummaryColumns}
              pagination={false}
              size="small"
              rowKey="method"
              summary={() => (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={1}>
                    <strong>Total</strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1} align="right">
                    <strong>{calculateTotalSales().toFixed(3)} </strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2} align="center">
                    <strong>{selectedInvoices.length}</strong>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              )}
            />
          </div>

          <div className="mb-4 p-3 border rounded">
            <div className="font-medium mb-2">Cash Reconciliation</div>
            <div className="grid grid-cols-2 gap-2 mb-2">
              <div>Opening Balance</div>
              <div className="text-right">{openingBalance.toFixed(3)}</div>

              <div>Cash Sales</div>
              <div className="text-right">
                {paymentSummary
                  .find((p) => p.method === "Cash")
                  ?.amount.toFixed(3) || "0.000"}{" "}
              </div>

              <div>Cash Sales Return</div>
              <div className="text-right text-red-500">
                - {returnPaymentSummary
                  .find((p) => p.method === "Cash")
                  ?.amount.toFixed(3) || "0.000"}{" "}
              </div>

              {calculateTotalCashIn() > 0 && (
                <>
                  <div className="font-medium">Cash In</div>
                  <div className="text-right text-green-500">
                    + {calculateTotalCashIn().toFixed(3)}
                  </div>

                  {cashInItems.map((item) => (
                    <React.Fragment key={item.id}>
                      <div className="text-xs ml-4 text-green-600">+ {item.reason}</div>
                      <div className="text-xs text-right text-green-600">
                        + {item.amount.toFixed(3)}
                      </div>
                    </React.Fragment>
                  ))}

                </>
              )}


              {calculateTotalCashOut() > 0 && (
                <>
                  <div className="font-medium">Cash Out</div>
                  <div className="text-right text-red-500">
                    - {calculateTotalCashOut().toFixed(3)}
                  </div>

                  {cashOutItems.map((item) => (
                    <React.Fragment key={item.id}>
                      <div className="text-xs ml-4">{item.reason}</div>
                      <div className="text-xs text-right text-red-500">
                        - {item.amount.toFixed(3)}
                      </div>
                    </React.Fragment>
                  ))}
                </>
              )}

              <div className="font-medium">Expected Cash</div>
              <div className="text-right font-medium">
                {expectedCash.toFixed(3)}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2 mt-2 pt-2 border-t">
              <div>Counted Cash</div>
              <div className="flex justify-end items-center">
                <InputNumber
                  value={cashCount}
                  onChange={handleCashCountChange}
                  min={0}
                  step={0.001}
                  precision={3}
                  className="w-32 mr-2"
                  formatter={(value) => `${value} `}
                  parser={(value) => value.replace(/ /g, "")}
                  controls={false}
                  keyboard={false}
                  onWheel={(e) => e.target.blur()}
                />
                <Button
                  type="primary"
                  onClick={() => setShowCashCountModal(true)}
                  className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
                >
                  Count
                </Button>
              </div>

              <div>Difference</div>
              <div
                className={`text-right ${cashDifference !== 0 ? "text-red-500" : "text-green-500"
                  }`}
              >
                {cashDifference.toFixed(3)}
              </div>
            </div>
          </div>

          {/* Closing Note */}
          <div className="mb-4">
            <div className="font-medium mb-2">Closing note</div>
            <Input.TextArea
              placeholder="Add a closing note..."
              value={closingNote}
              onChange={(e) => setClosingNote(e.target.value)}
              rows={3}
            />
          </div>
        </div>

        <div className="flex justify-between items-center pt-4 border-t">
          <div className="text-medium">
            Total Selected: {selectedInvoices.length} invoices
          </div>
          <div className="flex space-x-2">
            <Button
              className="text-red-500 border-2 border-red-500"
              onClick={handleCancel}
              disabled={loading}
            >
              Discard
            </Button>
            <Button
              type="primary"
              onClick={() => setShowCashInOutModal(true)}
              disabled={loading}
              className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
            >
              Cash In/Out
            </Button>
            <Button
              type="primary"
              onClick={handleSubmit}
              loading={loading}
              disabled={selectedInvoices.length === 0}
              className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]  
              disabled:!bg-[#a6e8c5] disabled:!border-[#a6e8c5] disabled:!text-black disabled:opacity-70"
            >
              Close Register
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        title="Cash In / Out"
        open={showCashInOutModal}
        onCancel={() => setShowCashInOutModal(false)}
        footer={[
          <Button key="cancel" onClick={() => setShowCashInOutModal(false)}
            className="text-red-500 border-2 border-red-500"
          >
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={addCashTransaction}
            className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
          >
            Confirm
          </Button>,
        ]}
        width={400}
      >
        <div className="mb-4">
          <div className="mb-2">Type</div>
          <Select
            value={cashInOutType}
            onChange={setCashInOutType}
            className="w-full"
          >
            <Option value="in">Cash In</Option>
            <Option value="out">Cash Out</Option>
          </Select>
        </div>

        <div className="mb-4">
          <div className="mb-2">Amount </div>
          <InputNumber
            value={cashInOutAmount}
            onChange={setCashInOutAmount}
            min={0}
            step={0.001}
            precision={3}
            className="w-full"
            controls={false}
            keyboard={false}
            onWheel={(e) => e.target.blur()}
          />
        </div>

        <div className="mb-4">
          <div className="mb-2">Reason</div>
          <Input
            value={cashInOutReason}
            onChange={(e) => setCashInOutReason(e.target.value)}
            placeholder="Enter reason"
          />
        </div>
      </Modal>

      <Modal
        title="Cash Count"
        open={showCashCountModal}
        onCancel={() => setShowCashCountModal(false)}
        footer={[
          <Button key="reset" onClick={resetCashCount}
            className="text-red-500 border-2 border-red-500"
          >
            Reset
          </Button>,
          <Button key="cancel" onClick={() => setShowCashCountModal(false)}
            className="text-red-500 border-2 border-red-500"
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => setShowCashCountModal(false)}
            className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"

          >
            Confirm
          </Button>,
        ]}
        style={{ top: 50, maxHeight: "70vh", overflowY: "auto" }}
      >
        <div className="grid grid-cols-2 gap-3 mb-4">
          {cashBreakdown.map((item, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-2 border rounded"
            >
              <span className="font-medium">
                {item.denomination.toFixed(3)}
              </span>
              <div className="flex items-center">
                <Button
                  size="small"
                  icon={<MinusOutlined />}
                  onClick={() =>
                    updateCashBreakdown(index, Math.max(0, item.count - 1))
                  }
                />
                <InputNumber
                  min={0}
                  value={item.count}
                  onChange={(value) => updateCashBreakdown(index, value || 0)}
                  className="w-16 mx-2"
                  controls={false}
                  keyboard={false}
                  onWheel={(e) => e.target.blur()}
                />
                <Button
                  size="small"
                  icon={<PlusOutlined />}
                  onClick={() => updateCashBreakdown(index, item.count + 1)}
                />
              </div>
              <span className="w-16 text-right">{item.value.toFixed(3)} </span>
            </div>
          ))}
        </div>

        <div className="flex justify-between items-center pt-2 border-t">
          <span className="font-medium">Total</span>
          <span className="font-medium text-lg">{cashCount.toFixed(3)} </span>
        </div>
      </Modal>
    </>
  );
};

export default CloseRegistryModal;